import axios from 'axios';

function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
}


export const maxios = axios.create({
    baseURL: 'https://admin.uktechexam.co.in/api/v1',
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN':getCookie('XSRF-TOKEN')
    },   
});


maxios.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
}, (error) => Promise.reject(error));
